import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const formatDate = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

export const AdminEditCorporateUser = () => {
    const { t } = useTranslation()
    const [data, setData] = useState([]);
    const [detail, setDetail] = useState([]);
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/User/UpdateUser`; // API_BASE_URL kullanımı
            await axios({
                method: 'PUT',
                url: url,
                data: {
                    id: data.id,
                    username: document.getElementById("username").value,
                    fullName: document.getElementById("fullName").value,
                    roleId: document.getElementById("roleId").value,
                    createdAt: data.createdAt,
                    lastLogin: data.lastLogin,
                    expiryDate: document.getElementById("expiryDate").value,
                    isTrial: data.isTrial,
                    isVerified: data.isVerified,
                    isInvidual: data.isInvidual,
                    isStudent: data.isStudent,
                    isManager: data.isManager,
                    schoolId: detail.schoolId,
                    classId: detail.classId,
                    sectionId: detail.sectionId,
                    userNote: ".",
                    status: "."
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {

                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        })
                    }
                    else {
                        setMsg(res.data['message']);
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            timer: 3000,
                            confirmButtonText: `Tamam`
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message);
            setMsg(err);
        }
    }
    const getUser = async (e) => {

        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/User/GetUserById`;
            await axios({
                method: 'GET',
                url: url,
                params: {
                    userId: params['id']
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setData(res.data['data']['user'])
                        setDetail(res.data['data']['detail'])
                    }
                    else {
                        alert(res.data['message']);
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err);
        }
        setLoading(false);
    }
    const fetchData = async () => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/Role/GetList`; // API_BASE_URL kullanımı
            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {

                if (res.status === 200) {
                    if (res.data['success']) {
                        setRoles(res.data['data']);
                    }
                    else {
                        alert("hata")
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            alert(err.message)
            setMsg(err);
        }
        setLoading(false);
    }
    useEffect(() => {
        getUser();
        fetchData();
    }, [])

    return (
        <div style={{ backgroundColor: "white", padding: "3%" }}>
            <div style={{ textAlign: "center" }}>
                <h1>{t("editUser")}</h1>
            </div>

            <h4>{msg}</h4>
            {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}

            {!loading && (
                <form onSubmit={handleSubmit} >
                    <div className="mb-3">
                        <label for="username" className="form-label">{t("email")}</label>
                        <textarea className="form-control" id="username" defaultValue={data.username} />
                    </div>

                    <div className="mb-3">
                        <label for="fullName" className="form-label"> {t('namesurname')} </label>
                        <textarea className="form-control" id="fullName" defaultValue={data.fullName} />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">{t('createdAt')}: {formatDate(data.createdAt)}</label>
                    </div>
                    <div className="mb-3">
                        <label className="form-label"> {t('lastLogin')} : {formatDate(data.lastLogin)}</label>
                    </div>


                    <div className="mb-3">
                        <label for="roleId" className="form-label">Rol seçiniz</label>
                        <select id="roleId" className="form-select">
                            {roles ? (
                                roles && roles.map((dt) => {
                                    if (data.roleName === dt.roleName) {
                                        return (
                                            <option key={dt.id} value={dt.id} selected>{dt.roleName}</option>
                                        );
                                    }
                                    else {
                                        return (
                                            <option key={dt.id} value={dt.id} >{dt.roleName}</option>
                                        );
                                    }
                                })
                            ) : (
                                <p>{t("reloadWarning")}</p>
                            )
                            }
                        </select>
                    </div>
                    <div className="mb-3">
                        <label className="form-label" for="expiryDate">{t("expiryDate")}</label>
                        <input type="datetime-local" className="form-control" id="expiryDate" name="expiryDate" defaultValue={data.expiryDate} />
                    </div>


                    <div className="mb-3">
                        <label for="isTrial" className="form-label">{t('isActive')}</label>
                        {data.isTrial ? (

                            <select id="isTrial" className="form-select" required >
                                <option key="0" value="true" selected>{t('passive')}</option>
                                <option key="1" value="false" >{t('active')}</option>
                            </select>
                        ) : (
                            <select id="isTrial" className="form-select" required >
                                <option key="1" value="false" selected>{t('active')}</option>
                                <option key="0" value="true" >{t('passive')}</option>
                            </select>
                        )}
                    </div>

                    <div className="mb-3">
                        <label for="schoolId" className="form-label"> {t('schoolId')} </label>
                        <textarea className="form-control" id="schoolId" defaultValue={detail.schoolId} />
                    </div>
                    <div className="mb-3">
                        <label for="sectionName" className="form-label"> {t('sectionName')} </label>
                        <textarea className="form-control" id="sectionName" defaultValue={detail.sectionName} />
                    </div>
                    <div className='d-flex justify-content-center'>
                        <button type="submit" className="btn btn-primary btn-lg">{t('update')}</button>
                    </div>

                </form>
            )}

        </div>
    );
};
export default AdminEditCorporateUser;
